<div class="modal-body height-900 width-600">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getGlobal('Company')}}&nbsp;{{getGlobal('zuordnen')}}
    </span>
    <div class="content">
      <div class="layout-list-quickfilter">
        <exg-search-bar (Search)="companyTable.search($event)" [placeholder]="getRessource('ListSearchHolder')"
                        class="span-layout">
          <ng-template #rightTemplate>
            <i class="search-action fal fa-sync" (click)="loadCompanyList()"></i>
            <i class="search-action fal fa-filter" (click)="togglePopupMenu($event, VCCompanyTableFilterPopup)"></i>
            <exg-popup #VCCompanyTableFilterPopup [closeAlways]="false" width="360">
              <app-exg-filter #VCCompanyTableFilterControl [MetaInfo]="companyTable.MetaInfo"
                              [visibility]="VCCompanyTableFilterPopup.visibility !== 'hidden'"
                              [uiFilter]="companyTable.uiFilter" [uiSort]="companyTable.uiSort" [showFilter]="true"
                              (onActivateFilter)="closePopupMenuAndReload();"></app-exg-filter>
            </exg-popup>
            <i class="search-action fal fa-sort-alt" (click)="togglePopupMenu($event, VCCompanyTableSortPopup)"></i>
            <exg-popup #VCCompanyTableSortPopup [closeAlways]="false" width="360">
              <app-exg-filter [MetaInfo]="companyTable.MetaInfo" [uiFilter]="companyTable.uiFilter"
                              [visibility]="VCCompanyTableSortPopup.visibility !== 'hidden'"
                              [uiSort]="companyTable.uiSort" [showSort]="true"
                              (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter>
            </exg-popup>
            <i class="search-action fal fa-binoculars" (click)="togglePopupMenu($event, VCCompanyTableSearchPopup)"></i>
            <exg-popup #VCCompanyTableSearchPopup [closeAlways]="false" width="360">
              <app-exg-filter [MetaInfo]="companyTable.MetaInfo" [uiFilter]="companyTable.uiFilter"
                              [uiSort]="companyTable.uiSort" [showSearch]="true"
                              [visibility]="VCCompanyTableSearchPopup.visibility !== 'hidden'"
                              (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter>
            </exg-popup>
          </ng-template>
        </exg-search-bar>
        <div class="content app-subarea">
          <exg-data-table #VCCompanyTable
                          (RowChange)="companyTable.selectionChanged($event)"
                          [allowSingleSelection]="true"
                          [displayState]="companyTable.state"
                          [rowSource]="companyTable.data"
                          containerClass="grid cols-8"
                          [selectKey]="companyTable.selectKey">
            <ng-template #headerTemplate>
              <div class="span-2 ">
                {{enumSvc.getFieldCaption("Company", "compName")}}
              </div>
              <div class="span-6 ">
                {{enumSvc.getFieldCaption("Company", "compLocation")}}
              </div>
            </ng-template>
            <ng-template #rowTemplate let-row>
              <div class="span-2">
                <p>{{row.compName}}</p>
              </div>
              <div class="span-6">
                <p>{{isNumberString(row.compCountry) ? enumSvc.getEnumerationTextA('Country', row.compCountry) : row.compCountry}}&nbsp;{{row.compZip}} {{row.compLocation}}</p>
              </div>
            </ng-template>
          </exg-data-table>
        </div>
        <div class="search-quickfilter">
          <i (click)="delete()"
             [class.disabled]="VCCompanyTable.selectedRow === -1"
             [tooltip]="'Löschen'"
             class="search-filter-action fal fa-trash-alt" flow="left">
          </i>
        </div>
        <exg-pager class="span-layout" *ngIf="companyTable.state === 0"
                   (PageChange)="companyTable.pageChanged($event)"
                   [pagingSource]="companyTable.paging">
          <ng-template #leftTemplate>
          </ng-template>
          <ng-template #rightTemplate>
            <span *ngIf="companyTable.isFiltered()">(gefiltert)</span>
          </ng-template>
        </exg-pager>
      </div>
    </div>
    <div class="spawn-modal-actions typo-small">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
      <button (click)="send()" class="md-btn"
        [disabled]="!companyTable.selectedRow">
        {{getGlobal('Choose')}}
      </button>
    </div>
  </div>
</div>
